import { inject, provide, ref, onMounted, watch, readonly } from 'vue';

import {
  routeKey,
  pageKey,
  getServerItemKey,
  subscribeKey,
  unsubscribeKey,
  Route,
} from '@drapejs/core';

export default function () {
  const route = inject(routeKey, <Route>(<any>{}));
  const page = inject(pageKey, ref<any>());
  const cache = {
    getServerItem: inject(getServerItemKey, () => null),
    subscribe: inject(subscribeKey, () => Promise.resolve()),
    unsubscribe: inject(unsubscribeKey, () => Promise.resolve()),
  };

  let selectedVariantBundlesCacheKey = getBundlesCacheKey(
    page.value.articleNumber,
    route.query.variant || ''
  );

  const selectedVariantBundles = ref<any>(
    readonly(cache.getServerItem(selectedVariantBundlesCacheKey) || [])
  );

  provide('selectedVariantBundles', readonly(selectedVariantBundles));

  onMounted(() => {
    watch(
      () => route.query.variant,
      () => {
        if (selectedVariantBundlesCacheKey) {
          cache.unsubscribe(
            selectedVariantBundlesCacheKey,
            bundlesCacheHandler
          );
        }

        selectedVariantBundlesCacheKey = getBundlesCacheKey(
          page.value.articleNumber,
          route.query.variant || ''
        );
        cache.subscribe(selectedVariantBundlesCacheKey, bundlesCacheHandler, {
          immediate: true,
        });
      },
      { immediate: true }
    );
  });

  return {
    bundles: selectedVariantBundles,
  };

  function bundlesCacheHandler(val: any) {
    selectedVariantBundles.value = readonly(val);
  }
}

export function getBundlesCacheKey(baseProductId: string, variantId: string) {
  return `product:bundle:${baseProductId}::${variantId}`;
}
